/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import fecha from 'fecha';
import * as queryString from '../../utils/queryString';

import '../../styles/RailModifySearch.css';
import '../../styles/railDayPicker.css';
import '../../styles/dayPickerRailReset.css';
import '../../styles/day-picker-style.css';
import '../../styles/railEnhancements.css';

import DayPickerInput from 'react-day-picker/DayPickerInput';
import AutoComplete from './RailAutoComplete';
import IrctcAutorizedPartner from './IrctcAuthorizedPartner';
import { isMobile } from '../../utils/commonUtils';
import { createTrackingCallback } from '../../utils/getPageSectionName';

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

class DesktopSearchBar extends React.Component {
  state = {
    dayPickerRef: React.createRef(),
    widget: null,
    selectedDay: undefined,
    inputName: 'travelDate',
    errorMessage: 'source and destination cannot be same',
    sourceAndDestinationSame: false
  };

  componentDidMount() {
    if (!isMobile()) {
      document.addEventListener('keydown', this.escFunction, false);
      // dont open datepicker on page load in mobile screens
      if (this.props.openDatePickerOnMount) {
        this.showDayPicker();
      }
    }
  }

  componentDidUpdate() {
    if (this.props.isCalendarOpen) {
      this.showDayPicker();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
  }

  onFromChange = (city, stn) => {
    const { code: toStn } = this.props.toStationNode;
    this.props.setFromCity(city, stn);
    this.closePopup();
    this.validateStations(stn, toStn);
  };

  onToChange = (city, stn) => {
    const { code: fromStn } = this.props.fromStationNode;
    this.props.setToCity(city, stn);
    this.closePopup();
    this.validateStations(fromStn, stn);
  };

  handlePopup = (idx, cName) => {
    if (cName) {
      this.setState({ widget: idx, inputName: cName });
    } else {
      this.setState({ widget: idx });
    }
  };

  showDayPicker = () => {
    this.dayPickerRef.showDayPicker();
    this.dayPickerRef.getInput().focus();
  };

  onShowDatePicker = () => {
    this.closePopup();
    this.handlePopup(2, 'travelDate');
    this.props.openCalendar();
  };

  onHideDatePicker = () => {
    this.closePopup();
  };

  closePopup = () => {
    const { closeCalendar } = this.props;
    this.setState({
      widget: null,
      inputName: null
    });
    closeCalendar && closeCalendar();
  };

  escFunction = (event) => {
    if (event.keyCode === 27) {
      this.closePopup();
    }
  };

  handleDayClick = (day, modifiers = {}) => {
    if (modifiers.disabled) {
      return;
    }
    this.closePopup();
    this.setState(
      {
        selectedDay: modifiers.selected ? this.state.selectedDay : day
      },
      () => {
        this.refreshRailListingData();
      }
    );
  };

  refreshRailListingData = () => {
    const { sourceAndDestinationSame, selectedDay } = this.state;

    const { city: fromCity, code: fromStn } = this.props.fromStationNode;
    const { city: toCity, code: toStn } = this.props.toStationNode;

    if (!fromStn) {
      this.handlePopup(0, 'fromCity');
      return;
    }
    if (!toStn) {
      this.handlePopup(1, 'toCity');
      return;
    }
    if (!selectedDay) {
      this.onShowDatePicker();
      return;
    }

    if (!selectedDay || sourceAndDestinationSame || !fromStn || !toStn) {
      return;
    }

    const doj = fecha.format(selectedDay, 'YYYYMMDD');
    const verifiedUserId = JSON.parse(localStorage.getItem('verifiedUserId'));
    const newQueryParams = {
      srcStn: fromStn,
      srcCity: fromCity,
      destStn: toStn,
      destCity: toCity,
      date: doj,
      classCode: '',
      verifiedUserId,
      trainNumber: this.props.trainNumber
    };
    const { verifiedUserId: id, ...urlParams } = newQueryParams;
    const newPath = `https://www.makemytrip.com/railways/listing/?isSeo=true&${queryString.stringify(urlParams)}`;
    window.location.href = newPath;
  };

  validateStations = (fromStn, toStn) => {
    if (fromStn === toStn) {
      this.setState({
        sourceAndDestinationSame: true
      });
    } else {
      this.setState({
        sourceAndDestinationSame: false
      });
    }
  };

  render() {
    const { selectedDay, widget, from, sourceAndDestinationSame, errorMessage, isCalendarOpen } = this.state;
    const isMobile = () => typeof window !== 'undefined' && window && window.innerWidth < 767;
    const { topFix } = this.props;
    //changing search widget from and to city names to english in desktop
    if (!isMobile() && this.props.sourceCityEn && this.props.destinationCityEn) {
      this.props.fromStationNode.city = this.props.sourceCityEn;
      this.props.toStationNode.city = this.props.destinationCityEn;
    }
    const { city: fromCity, code: fromStn } = this.props.fromStationNode;
    const { city: toCity, code: toStn } = this.props.toStationNode;

    const today = new Date();
    const lastAllowedDate = new Date();
    const numberOfDaysToAdd = today.getHours() > 8 || (today.getHours() === 8 && today.getMinutes() > 15) ? 120 : 119;

    lastAllowedDate.setDate(lastAllowedDate.getDate() + numberOfDaysToAdd);
    const disabledDays = {
      before: today,
      after: lastAllowedDate
    };

    const arr = [
      <React.Fragment>
        <AutoComplete placeholder="From" closeCityPopup={this.closePopup} onChange={this.onFromChange} />
        <div className="hsBackDrop" onClick={this.closePopup} />
      </React.Fragment>,
      <React.Fragment>
        <AutoComplete placeholder="To" closeCityPopup={this.closePopup} onChange={this.onToChange} />
        <div className="hsBackDrop" onClick={this.closePopup} />
      </React.Fragment>
    ];

    const pageName = this.props.pageName;

    return (
      <>
        <div className={`desktopShow  ${topFix ? 'widgetFix' : ''}`}>
          <div className={`rsw widgetOpen`} id="railModifySearch">
            <div className="rsw_inner">
              <div
                className={`rsw_inputBox selectHtlCity ${widget !== null ? 'inactiveWidget' : ''} ${
                  widget === 0 ? 'activeWidget' : ''
                }`}
                onClick={createTrackingCallback(pageName, 'rail_seo_{{pageSectionName}}_stationfrom_click')}
              >
                <label htmlFor="fromCity" className="lbl_input makeFlex column latoBold">
                  <span className="appendBottom5 font12 capText deepskyBlueText">From City</span>
                  <input
                    id="fromCity"
                    type="text"
                    className={`rsw_inputField font16 whiteText ${fromCity?.length > 10 ? 'truncate' : ''}`}
                    value={`${fromStn}${fromCity?.length > 0 ? ',' : ''} ${fromCity || ''}`}
                    onFocus={(event) => this.handlePopup(0, 'fromCity', event)}
                    readOnly
                  />
                </label>
                {widget === 0 && arr[widget]}
              </div>
              <div
                className={`rsw_inputBox selectHtlCity ${widget !== null ? 'inactiveWidget' : ''} ${
                  widget === 1 ? 'activeWidget' : ''
                }`}
                onClick={createTrackingCallback(pageName, 'rail_seo_{{pageSectionName}}_stationto_click')}
              >
                <label htmlFor="toCity" className="lbl_input latoBold makeFlex column">
                  <span className="appendBottom5 font12 capText deepskyBlueText">To City</span>
                  <input
                    id="toCity"
                    type="text"
                    className={`rsw_inputField font16 whiteText ${toCity?.length > 10 ? 'truncate' : ''}`}
                    value={`${toStn}${toCity?.length > 0 ? ',' : ''} ${toCity || ''}`}
                    onFocus={(event) => this.handlePopup(1, 'toCity', event)}
                    readOnly
                  />
                </label>
                {widget === 1 && arr[widget]}
              </div>
              <div
                className={`rsw_inputBox dayPickerRailWrap dates ${widget !== null ? 'inactiveWidget' : ''} ${
                  isCalendarOpen ? 'activeWidget' : ''
                }`}
                onClick={createTrackingCallback(pageName, 'rail_seo_{{pageSectionName}}_date_click')}
              >
                <label htmlFor="travelDate" className="lbl_input latoBold makeFlex column">
                  <span className="appendBottom5 font12 capText deepskyBlueText">TRAVEL DATE</span>
                  <input
                    id="travelDate"
                    type="text"
                    className="rsw_inputField font16 whiteText"
                    value={from}
                    readOnly
                  />
                  <p className="font16 sCapText whiteText dateText">
                    {selectedDay && (
                      <React.Fragment>
                        <span className="code latoRegular">{days[selectedDay.getDay()]},&nbsp;</span>
                        <span className="code paddingTB2">
                          <span className="latoBlack">{selectedDay.getDate()}</span>
                          <span className="latoRegular"> {months[selectedDay.getMonth()]}</span>
                          <span className="latoRegular shortYear"> {selectedDay.getFullYear() % 2000} </span>
                        </span>
                      </React.Fragment>
                    )}
                  </p>
                </label>
                <label htmlFor={'dayPickerPopUp'}>
                  <div className="dayPickerHotelWrap desktop">
                    <DayPickerInput
                      ref={(el) => (this.dayPickerRef = el)}
                      dayPickerProps={{
                        onDayClick: this.handleDayClick,
                        selectedDays: selectedDay,
                        fromMonth: new Date(),
                        toMonth: lastAllowedDate,
                        initialMonth: selectedDay,
                        disabledDays: disabledDays
                      }}
                      onDayPickerShow={() => this.onShowDatePicker()}
                      onDayPickerHide={() => this.onHideDatePicker()}
                    />
                  </div>
                </label>
              </div>
              <p className="paddingLR20 makeFlex vrtlCenter">
                <button
                  className={`${
                    sourceAndDestinationSame ? 'disabled' : ''
                  } primaryBtn font18 latoBlack widgetSearchBtn`}
                  onClick={() => {
                    const trackingCb = createTrackingCallback(pageName, 'rail_seo_{{pageSectionName}}_search_click');
                    trackingCb();
                    this.refreshRailListingData();
                  }}
                >
                  <span className="font14 latoBlack capText">Search</span>
                </button>
              </p>

              {sourceAndDestinationSame && <span className="font14 redText appendLeft20 latoBold">{errorMessage}</span>}
            </div>
          </div>
          <IrctcAutorizedPartner />
        </div>
      </>
    );
  }
}

DesktopSearchBar.propTypes = {
  fromStationNode: PropTypes.object.isRequired,
  closeCalendar: PropTypes.func,
  openCalendar: PropTypes.func,
  setToCity: PropTypes.func,
  setFromCity: PropTypes.func,
  toStationNode: PropTypes.object.isRequired,
  isCalendarOpen: PropTypes.bool,
  openDatePickerOnMount: PropTypes.bool,
  topFix: PropTypes.bool.isRequired,
  sourceCityEn: PropTypes.string.isRequired,
  destinationCityEn: PropTypes.string.isRequired,
  pageName: PropTypes.string
};

DesktopSearchBar.defaultProps = {
  isCalendarOpen: false,
  closeCalendar: undefined,
  openCalendar: undefined,
  openDatePickerOnMount: false,
  sourceCityEn: '',
  destinationCityEn: ''
};

export default DesktopSearchBar;
